"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1FavoritesGet = void 0;
exports.v1FavoritesGetSetMock = v1FavoritesGetSetMock;
exports.v1FavoritesGet = v1FavoritesGet;
exports.useQueryV1FavoritesGet = useQueryV1FavoritesGet;
exports.useInfiniteQueryV1FavoritesGet = useInfiniteQueryV1FavoritesGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1FavoritesGetSetMock(mock) {
    setMock = mock;
}
async function v1FavoritesGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/favorites`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.challengeStoreEnabled = params.challengeStoreEnabled;
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.page = params.page;
    queryParams.pageSize = params.pageSize;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1FavoritesGet = 'wolf-dashboard-service:v1FavoritesGet:get';
function useQueryV1FavoritesGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1FavoritesGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1FavoritesGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1FavoritesGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1FavoritesGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-favorites-get.js.map